type JwtPayload = {
  course_editor?: {
    mode?: string;
  };
};

const decodePayload = (token: string): JwtPayload | null => {
  try {
    const segment = token.split('.')[1];
    if (!segment) return null;

    const base64 = segment.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64.padEnd(Math.ceil(base64.length / 4) * 4, '=');
    return JSON.parse(window.atob(padded)) as JwtPayload;
  } catch {
    return null;
  }
};

const isTranslationsOnlyToken = (token: string | null): boolean =>
  token !== null &&
  decodePayload(token)?.course_editor?.mode === 'translations';

export const isTranslationsOnlySession = (search: string): boolean => {
  const params = new URLSearchParams(search);

  return (
    params.get('editingMode') === 'translations' ||
    isTranslationsOnlyToken(params.get('token'))
  );
};
